import React from 'react';
import Icon from '../ui/Icon';
import Modal from '../ui/Modal';
import { PHONE_W, PHONE_H, PHONE_LARGE_SCALE } from './PhonePreview';
import phone from './PhonePreview.module.css';
import stylesSelf from './SmsPreview.module.css';

// Literal preview — `text` is exactly what sms.provider.js sends via SNS
// PublishCommand, so this renders the real message body.
function Frame({ text, templateId, scale = 1 }) {
  return (
    <div style={{ width: PHONE_W * scale, height: PHONE_H * scale }}>
      <div className={phone.phone} style={scale !== 1 ? { transform: `scale(${scale})`, transformOrigin: 'top left' } : undefined}>
        <div className={phone.notch} />
        <div className={phone.time}>9:41</div>
        <div className={stylesSelf.thread}>
          <div className={stylesSelf.sender}>PMWGIG</div>
          <div className={stylesSelf.bubble}>{text || 'Your SMS text appears here…'}</div>
          {templateId && <div className={stylesSelf.tplBadge}>Template: {templateId}</div>}
        </div>
      </div>
    </div>
  );
}

class SmsPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  render() {
    const { text = '', templateId = '' } = this.props;
    const { expanded } = this.state;
    return (
      <div className={phone.wrap}>
        <div className={phone.labelRow}>
          <span className={phone.label}>Live Preview</span>
          <button type="button" className={phone.expandBtn} title="Enlarge preview" onClick={() => this.setState({ expanded: true })}>
            <Icon name="open_in_full" size={11} />
          </button>
        </div>
        <Frame text={text} templateId={templateId} />
        <div className={phone.caption}>SMS thread · preview only</div>

        <Modal open={expanded} onClose={() => this.setState({ expanded: false })} title="SMS — full preview" width="fit-content">
          <Frame text={text} templateId={templateId} scale={PHONE_LARGE_SCALE} />
        </Modal>
      </div>
    );
  }
}

export default SmsPreview;
